var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11111 1H1V2.11111V3.22222H2.11111V2.11111H9.88889V9.88889H2.11111V8.77778H1V9.88889V11H2.11111H9.88889H11V9.88889V2.11111V1H9.88889H2.11111ZM8.77778 5.44444H7.66667V4.33333H6.55556L6.55556 3.22222H5.44444V4.33333L6.55556 4.33333V5.44444H1V6.55556H6.55556V7.66667H5.44444V8.77778H6.55556L6.55556 7.66667H7.66667V6.55556H8.77778V5.44444Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11111 1H9.88889H11V2.11111V3.22222H9.88889V2.11111H2.11111V9.88889H9.88889V8.77778H11V9.88889V11H9.88889H2.11111H1V9.88889V2.11111V1H2.11111ZM11 5.44444H9.88889V4.33333H8.77778V3.22222H7.66667V4.33333L8.77778 4.33333V5.44444H3.22222V6.55556H8.77778V7.66667H7.66667V8.77778H8.77778V7.66667H9.88889V6.55556H11V5.44444Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginS);
export default __webpack_public_path__ + "static/media/login-s.3f8cb83bf6f085ddbd88019e8015d115.svg";
export { ForwardRef as ReactComponent };